import { useEffect, useState, MutableRefObject } from 'react'
export function useIsVisible(ref: MutableRefObject<any>, options?: IntersectionObserverInit) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), options)

    observer.observe(ref.current)
    return () => {
      observer.disconnect()
    }
  }, [ref])

  return isIntersecting
}
